import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconFrameGlobe(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
      <rect
        x="0.600006"
        width="24"
        height="24"
        rx="6"
        fill={props.fill ?? '#F2F5F7'}
      />
      <g clipPath="url(#clip0_5473_191269)">
        <path
          d="M12.6 17C15.3615 17 17.6 14.7614 17.6 12C17.6 9.23859 15.3615 7.00002 12.6 7.00002C9.83861 7.00002 7.60004 9.23859 7.60004 12C7.60004 14.7614 9.83861 17 12.6 17Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.60004 12H17.6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6 7.00002C13.8507 8.36919 14.5614 10.146 14.6 12C14.5614 13.854 13.8507 15.6308 12.6 17C11.3494 15.6308 10.6387 13.854 10.6 12C10.6387 10.146 11.3494 8.36919 12.6 7.00002V7.00002Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5473_191269">
          <rect width="12" height="12" fill="white" transform="translate(6.60001 6)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconFrameGlobe = forwardRef(_IconFrameGlobe)
